import React, { useEffect, useState } from 'react';

import slugify from 'utils/slugify';
import useScroll from 'utils/useScroll';
import { useRouter } from 'next/router';
import { MobileMenu, MobileMenuItems, MobileMenuItem } from './styles';

const Menu = ({ categories, toggleMenu }) => {
  const [sections, setSections] = useState([]);
  const { pathname, push } = useRouter();

  const onDashboard = pathname === '/user/classes';

  useEffect(() => {
    if (categories?.length) {
      const newSections = categories.map((category) => {
        const node = document.getElementById(slugify(category));
        return node;
      });
      setSections(newSections);
    }
  }, [categories]);

  // disable body scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  });

  const { scrollY } = useScroll();
  const actualScrollY = scrollY + 68 * 2;
  const activeCategory = sections.find(
    (section) =>
      section &&
      actualScrollY >= section.offsetTop &&
      actualScrollY <= section.offsetTop + section.offsetHeight
  );

  return (
    <MobileMenu>
      <MobileMenuItems>
        {/* dashboard categories */}
        {/* {onDashboard ? (
          <>
            {categories.map((category) => (
              <MobileMenuItem
                active={activeCategory && activeCategory.id === slugify(category)}
                key={slugify(category)}
                aria-label={category}
                onClick={() => {
                  toggleMenu();
                  setTimeout(() => {
                    document.getElementById(slugify(category)).scrollIntoView();
                  }, 100);
                }}
              >
                <span>{category}</span>
              </MobileMenuItem>
            ))}
          </>
        ) : null} */}

        <MobileMenuItem>
          <a
            href="https://www.mindbodygreen.com/"
            title="read"
            aria-label="mind body green home page"
          >
            read
          </a>
        </MobileMenuItem>
        <MobileMenuItem>
          <a href="https://institute.mindbodygreen.com/" title="Learn" aria-label="Learn">
            learn
          </a>
        </MobileMenuItem>
        <MobileMenuItem>
          <a href="https://shop.mindbodygreen.com/" title="Shop" aria-label="Shop">
            shop
          </a>
        </MobileMenuItem>
        <MobileMenuItem>
          <a href="https://www.mindbodygreen.com/podcasts" title="Listen" aria-label="Listen">
            listen
          </a>
        </MobileMenuItem>
        <MobileMenuItem
          dividerTop
          active={!activeCategory && onDashboard}
          onClick={() => {
            toggleMenu();
            push('/user/classes');
          }}
        >
          <span>Class Dashboard</span>
        </MobileMenuItem>
      </MobileMenuItems>
    </MobileMenu>
  );
};

export default Menu;
